<mat-card class="device-card">
    <mat-card-header>
        <mat-card-title>
            <mat-icon [matTooltip]="getTypeLabel()">{{ getTypeIcon() }}</mat-icon>
            {{ device.deviceName }}
        </mat-card-title>
        <mat-card-subtitle>
            <mat-chip [ngClass]="getStatusClass()" class="status-chip">
                <mat-icon>{{ getStatusIcon() }}</mat-icon>
                {{ device.deviceStatus }}
            </mat-chip>
        </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
        <!-- Device Info -->
        <div class="info-row" class="info-label">Type:
            <span class="info-value">{{ getTypeLabel() }}</span>
        </div>

        @if (device.deviceHardwareID) {
        <div class="info-row">
            <span class="info-label">Hardware ID:</span>
            <code>{{ device.deviceHardwareID }}</code>
        </div>
        }

        @if (device.deviceDescription) {
        <div class="info-row">
            <span class="info-label">Description:</span>
            <span class="info-value">{{ device.deviceDescription }}</span>
        </div>
        }

        @if (device.deviceAddress) {
        <div class="info-row">
            <span class="info-label">Address:</span>
            <span class="info-value">
                {{ device.deviceAddress.firstAddressLine }}
                @if (device.deviceAddress.secondAddressLine) {
                , {{ device.deviceAddress.secondAddressLine }}
                }
                @if (device.deviceAddress.locality) {
                , {{ device.deviceAddress.locality }}
                }
                @if (device.deviceAddress.region) {
                , {{ device.deviceAddress.region }}
                }
            </span>
        </div>
        }

        @if (device.id) {
        <div class="info-row">
            <span class="info-label">ID:</span>
            <code class="id-code">{{ device.id }}</code>
        </div>
        }
    </mat-card-content>
</mat-card>